
import { computed, defineComponent, markRaw } from 'vue';
import { useStore } from 'vuex';
import { Actions, Getters } from '@/store';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';
import HostExchangeManager from '@/manager/2.6/HostExchangeManager';
import AddManualComp from '@/modules/add-manual-comp/components/AddManualComp.vue';
import ModalConfirmation from '@/components/modals/Confirmation.vue';
import HostUtils from '@/utils/HostUtils';
import LogUsageManager from '@/manager/LogUsageManager';
import MlsFetchManager from '@/manager/2.6/MlsFetchManager';
import CompsManager from '@/manager/2.6/CompsManager';
import QSUtils from '@/utils/QSUtils';

export default defineComponent({
    components: { ModalBody, AddManualComp, ModalConfirmation },
    data() {
        return {
            modal: null,
            addManualCompCallback: [],
            modalConformation: {
                show: false,
                component: markRaw(ModalConfirmation),
                message: '',
                size: '',
                buttons: [] as any,
            },
        };
    },
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    mounted() {
        QSUtils.removeElementById('JumpStart');

        const modalElement = this.$refs.jumpStart;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, 'xl');
        ModalService.open(this.modal);
    },
    methods: {
        async addComp() {
            const elForm = document.getElementById('addManualComp') as HTMLElement;
            var forms = document.querySelectorAll('.needs-validation');
            Array.prototype.filter.call(forms, function (form) {
                if (!form.checkValidity()) {
                    form.classList.add('error-validated');
                } else {
                    form.classList.remove('error-validated');
                }

                form.classList.add('was-validated');
            });

            if (!elForm.classList.contains('error-validated')) {
                await CompsManager.addManualComps(this.addManualCompCallback);

                // Validation check.
                const computedHasComps = computed(() => this.store.getters[Getters.CompAddresses.HasComps]);
                if (computedHasComps.value) {
                    // If the Jump Start modal is shown and successful import, then default active comp to 1
                    CompsManager.setActiveComp(1);

                    LogUsageManager.addCompManually();

                    MlsFetchManager.processToComps(); // Not awaiting?

                    (this as any).eventBus.emit('checkTabOverflow');

                    this.addCompCloseModal();
                } else {
                    // Noting was imported. If there is only one property (Subject) and only one maunally entered comp
                    // and they match we need to notify then user.
                    this.modalConformation.show = true;
                    this.modalConformation.message = 'Your comp address matches the subject. Please enter a different address to continue.';
                    this.modalConformation.buttons = [
                        {
                            label: 'Close',
                            css: 'btn-outline-secondary',
                        },
                    ];
                }
            }
        },
        getLink(): string {
            let result = `https://www.alamode.com/?v=530450629`;
            if (HostUtils.isTotal()) {
                result = `https://www.alamode.com/?v=530450629&popout=1`;
            }
            return result;
        },
        getTarget(): string {
            let result = `_blank`;
            if (HostUtils.isTotal()) {
                result = ``;
            }
            return result;
        },
        AddManualCompCallback(obj: any) {
            this.addManualCompCallback = obj;
        },
        async exitApplication() {
            await HostExchangeManager.closeApp(false);
        },
        async launchMLSImportFromJumpStartModal() {
            ModalService.hide(this.modal);
            (this as any).eventBus.emit('modalMLSImport');
        },
        addCompCloseModal() {
            QSUtils.removeElementById('JumpStart');
            ModalService.hide(this.modal);
        },
    },
});
